
import React from 'react';
import { Box, Tab, Tabs } from 'grommet';

import LayersPanel from './LayersPanel';
import LegendPanel from './LegendPanel';
import InfoPanel from './InfoPanel';

const TAB_INDEX_INFO = 2;

class Panels extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        };
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.map.foundObjects) &&
            (nextProps.map.foundObjects !== this.props.map.foundObjects)) {
            this.setState({activeIndex: TAB_INDEX_INFO});
        }
    }

    handleOnActive = (tabIndex) => {
        this.setState({activeIndex: tabIndex});
    }

    render() {
        return (
            <Box flex="grow">
                <Tabs
                    flex="grow"
                    justify="start"
                    activeIndex={this.state.activeIndex}
                    onActive={this.handleOnActive}
                >
                    <Tab title="Vrstvy">
                        <Box pad={{top: '12px'}}>
                            <LayersPanel
                                layers={this.props.map.layers}
                                groups={this.props.map.groups}
                                setLayerVisibility={this.props.setLayerVisibility}
                            />
                        </Box>
                    </Tab>
                    <Tab title="Legenda" flex="grow">
                        <Box flex="grow" pad={{top: '12px'}} height="100%">
                            <LegendPanel
                                layers={this.props.map.layers}
                                legend={this.props.map.legend}
                                getLegend={this.props.getLegend}
                            />
                        </Box>
                    </Tab>
                    <Tab title="Informace">
                        <Box pad={{top: '12px'}}>
                            <InfoPanel
                                foundObjects={this.props.map.foundObjects}
                                points={this.props.map.points}
                                clear={this.props.clear}
                            />
                        </Box>
                    </Tab>
                </Tabs>
            </Box>
        );
    }
}

export default Panels;
